/**
 * <HorizontalInfoGrid
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './HorizontalInfoGrid.scss';

class HorizontalInfoGrid extends React.Component {
  static propTypes = {
    data: PropTypes.array,
  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }

  render() {
    const {
      data,
    } = this.props;

    let ths = [];
    let tds = [];

    data.map(({label, value})=>{
      ths.push(label);
      tds.push(value);
    });

    return (
      <div className='horizontalInfoGrid'>
        <table>
          <thead>
            <tr>{ths.map((th, key)=>{
                return <th key={key}>{th}</th>
              })}</tr>
          </thead>
          <tbody>
            <tr>{tds.map((th, key)=>{
                return <td key={key}>{th}</td>
              })}</tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default HorizontalInfoGrid;



// WEBPACK FOOTER //
// ./src/components/UI/HorizontalInfoGrid/index.js